import triggerChangeEvent from 'DOM/triggerChangeEvent';

const handlePlusQuantity = (item, e) => {
  e.preventDefault();
  const input = item.querySelector("input[type=number].quantity");
  input.value = parseInt(input.value) + 1;
  triggerChangeEvent(input, { bubbles: true });
}

export default handlePlusQuantity;
